import liveboardFromJs from 'models/liveboards/liveboard_from_js';

export default {
  fromDto(dto, liveboardType) {
    return liveboardFromJs({ ...dto, type: liveboardType });
  },
};



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/liveboard_converter.js